import { EChartService } from './echart.service';
import { CharacterMappingData, StatsCharacterMapping } from '@/models/statistics/stats-character-mapping';
import i18n from '@/i18n';

export class CharacterMappingEchartService extends EChartService {
  constructor() {
    super();
    this.series = [];
  }

  /**
   * AIGROW2-184 箱ひげ図にデータテーブルを追加
   * 箱ひげ図のみにデータを表形式で表示する
   * EChartService が箱ひげ図以外のグラフでも共通なので、空配列を返すだけのものを追加しています
   * subTableColmuns
   * subTableData
   */
  get subTableColmuns(): any[] {
    return [];
  }
  get subTableData(): any[] {
    return [];
  }

  get options() {
    return {
      legend: {
        data: this.series.map((solo: any, index: number) => {
          return `SN-${index + 1}`;
        }),
        left: 'center',
      },
      xAxis: {
        axisLabel: {
          show: false,
        },
      },
      yAxis: {
        axisLabel: {
          show: false,
        },
      },
      toolbox: {
        show: true,
        top: '50',
        right: 10,
        itemSize: 15,
        feature: {
          dataZoom: { show: true, title: { zoom: i18n.t('ENLARGE').toString(), back: i18n.t('UNDO').toString() } },
          restore: { show: true, title: i18n.t('RESET').toString() },
        },
      },
      tooltip: {
        formatter: function(params: any) {
          return params.name;
        },
      },
      series: this.series,
    };
  }

  addSeries(chartData: StatsCharacterMapping): void {
    this.series.push({
      symbolSize: 10,
      name: `SN-${this.series.length + 1}`,
      data: chartData.data.map((d: CharacterMappingData) => {
        return {
          name: d.student.fullName,
          value: d.value,
          studentID: d.student.studentID,
          isLink: true,
          label: {
            show: true,
            // formatter: '{b}: {@label}',
            formatter: function(params: any) {
              return params.name;
            },
            // color: '#000000',
            // fontSize: 10,
            // fontWeight: 'bold',
            position: 'top',
            distance: 3,
          },
        };
      }),
      type: 'scatter',
    });
  }
}
